import { Clock } from 'lucide-react';
import { Button } from '@zaogig/ui/button';

interface WorkDurationDisplay {
  hours: number;
  minutes: number;
}

interface WorkingPhaseProps {
  workDuration: WorkDurationDisplay | null;
  checkInTime?: string;
  onCheckOut: () => void;
}

export function WorkingPhase({
  workDuration,
  checkInTime,
  onCheckOut
}: WorkingPhaseProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6 relative">
        <Clock className="w-12 h-12 text-green-600" />
        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full animate-pulse" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">工作中</h2>

      {workDuration && (
        <div className="text-center mb-6">
          <p className="text-3xl font-bold text-blue-600">
            {workDuration.hours}时{workDuration.minutes}分
          </p>
          <p className="text-gray-500 text-sm">已工作时长</p>
        </div>
      )}

      {checkInTime && (
        <p className="text-gray-500 mb-8">
          上班时间: {checkInTime}
        </p>
      )}

      <Button
        onClick={onCheckOut}
        className="w-full bg-orange-600 hover:bg-orange-700"
      >
        下班打卡
      </Button>
    </div>
  );
}
